import * as Api from '@Api/index';

import type { ApiResponse } from '@Types/Api';
import type { CountryCode } from '@Types/Base';

export interface Body {
  /** Идентификатор региона */
  id: number;
  latitude: number;
  longitude: number;
  region: string;
  country: CountryCode;
}

export interface Response {
  cost: number;
}

/**
 * Возвращает стоимость доставки
 */
const getDeliveryCostByRegion = async (body: Body) => {
  const url = `/shipping/api/get-region-cost`;

  const response = await Api.queryProxi<ApiResponse<Response>>(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) return Promise.reject(response);

  return response;
};

export default getDeliveryCostByRegion;
